import { render } from "./StakeAccount.vue?vue&type=template&id=5cabf3be"
import script from "./StakeAccount.vue?vue&type=script&lang=js"
export * from "./StakeAccount.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/StakeAccount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5cabf3be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5cabf3be', __exports__)) {
    api.reload('5cabf3be', __exports__)
  }
  
  module.hot.accept("./StakeAccount.vue?vue&type=template&id=5cabf3be", () => {
    api.rerender('5cabf3be', render)
  })

}


export default __exports__